<template>
  <div>
    <div class="box">
      <h2 class="title">{{ user.name }}</h2>

      <p class="data-control">
        <span class="label">{{$t('global.form.email.title')}}</span>
        {{ user.email }}
      </p>

      <p class="data-control">
        <span class="label">{{$t('global.form.document.title')}}</span>
        {{ user.document }}
      </p>

      <p v-if="user.birthdate" class="data-control">
        <span class="label">{{$t('global.form.birthdate.title')}}</span>
        {{ user.birthdate | moment("DD/MM/YYYY") }}
      </p>

      <button class="button is-icon is-edit" @click="edit">{{$t('global.edit')}}</button>
    </div>

    <zul-modal ref="modal" :title="$t('profile.edit.title')" :primary="$t('global.save')" :secondary="$t('global.changePassword')" :tertiary="$t('global.deleteAccount')" @primary="save" @secondary="resetPassword" @tertiary="deleteAccount" >
      <fieldset class="form">
        <zul-input type="text" v-model="form.name" name="name" icon="buddy" v-validate="'required|alpha_spaces'" :label="$t('global.form.name.title')"></zul-input>
        <zul-input type="email" v-model="form.email" name="email" icon="email" v-validate="'required|email'" :label="$t('global.form.email.title')"></zul-input>
        <zul-input type="tel" v-model="user.document" name="document" icon="document" v-validate="'required|document'" :label="$t('global.form.document.title')" disabled></zul-input>
        <zul-input type="tel" v-if="user.birthdate" v-model="form.birthdate" name="birthdate" icon="calendar" v-validate="'required|date_format:dd/MM/yyyy'" :label="$t('global.form.birthdate.title')"  mask="##/##/####"></zul-input>
      </fieldset>
    </zul-modal>

    <zul-modal ref="passwordModal" :title="$t('profile.resetPassword.title')" :primary="$t('global.send')" :secondary="$t('global.back')" @primary="resend" @secondary="edit">
      <p v-if="!resetSent" v-html="$t('profile.resetPassword1', [user.email])" class="passwordModal-description" />
      <p v-else>{{$t('profile.resetPassword2', [user.email])}}</p>
    </zul-modal>

    <zul-modal ref="deleteAccountModal" :title="$t('profile.deleteAccount.title')" :primary="$t('profile.deleteAccount.confirmButton')" :secondary="$t('global.back')" @primary="confirmAccountDeletion" @secondary="edit">
      <p v-html="$t('profile.deleteAccount.description')" class="has-text-centered" />
    </zul-modal>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    const user = this.$auth.user()
    const date = (user.birthdate || '').split('-')

    return {
      user: user,
      form: {
        name: user.name,
        email: user.email,
        birthdate: user.birthdate ? `${date[2]}/${date[1]}/${date[0]}` : null
      },
      resetSent: false
    }
  },
  methods: {
    edit () {
      // set default
      this.$refs.passwordModal.close()
      this.$refs.deleteAccountModal.close()

      this.$refs.modal.open()
    },
    save () {
      const $modal = this.$refs.modal
      $modal.isLoading = true

      const date =  (this.form.birthdate || '').split('/')

      const formData = {
        name: this.form.name,
        email: this.form.email,
        birthdate: `${date[2]}-${date[1]}-${date[0]}`
      }

      this.$http.put('user', formData).then(res => {
        $modal.isLoading = false

        this.user = res.data
        this.$auth.user(res.data)

        this.$refs.modal.close()
      })
    },

    resetPassword () {
      this.resetSent = false
      this.$refs.passwordModal.setProps({ labels: { primary: this.$t('global.send') } })

      this.$refs.modal.close()
      this.$refs.passwordModal.open()
    },

    deleteAccount () {
      this.$refs.modal.close();
      this.$refs.deleteAccountModal.open();
    },

    confirmAccountDeletion() {
      this.$refs.deleteAccountModal.startLoading();

      this.$http.get('/user/request-delete').then(() => {
        this.$auth.logout();

        this.$buefy.toast.open({
          message: this.$t('global.profile.deleteAccount.successMessage'),
          type: "is-success",
        });
      }).catch((error) => {
        const message =
        (((error || {}).response || {}).data || {}).message || this.$t('global.error.message');

        this.$buefy.toast.open({
          message,
          type: "is-danger",
        });
      }).finally(() => {
        this.$refs.deleteAccountModal.stopLoading();
      });
    },

    resend () {
      this.$refs.passwordModal.startLoading()
      this.$refs.passwordModal.setProps({ labels: { primary: null } })
      const data = new FormData();

      data.append('document', this.user.document)
      data.append('email', this.user.email)

      this.$http.post('auth/password/resend', data)
        .then(() => {
          this.resetSent = true

          setTimeout(() => {
            this.$refs.passwordModal.close()
            this.$refs.passwordModal.stopLoading()
          }, 6000);
        }, () => {
          this.resetSent = false
          this.$refs.passwordModal.setProps({ labels: { primary: this.$t('global.send') } })
          this.$refs.passwordModal.stopLoading()
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../assets/sass/variables';

  .dashboard .box > .title {
    font-size: $size-5;
  }

  .label {
    color: #666;
    font-size: 13px;
  }

  .button {
    position:  absolute;
    right: 24px;
    top: 24px;
    opacity: .5;
  }
</style>

<style>
.passwordModal-description {
  strong {
    color: #fff;
  }
}
</style>
